import { Select, Option, Checkbox } from 'element-ui';
import ResourceSvc from '@/services/resource.svc.js';
import 'element-ui/lib/theme-chalk/index.css';
const svc = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

export default {
    name: 'RaceResult',
    props: ['loadedResultsInput', 'raceId', 'raceName'],
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Checkbox.name]: Checkbox
    },
    data() {
        return {
            isOnlyQualified: false,
            previousColor: null,
            emptyCell: "-",
            indexPoints: 2,
            indexGender: 4,
            indexAgeGroup: 6,
            indexClub: 12,
            indexFirstName: 8,
            indexLastName: 9,
            indexTiNumber: 7,
            indexSerie: 26,
            seriesLoaded: ["All Results", "Non Series"],
            serieSelected: "All Results",

            loadedResultsVisible:[],
            loadedResultsFiltered: [],
            filterInput: null,
            ageGroupSelected: null,
            ageGroupArray: [],
            genderSelected: "Mixed",
            genderArray: [{ label: "Male", enumValue: "Male" }, { label: "Female", enumValue: "Female" }, { label: "Mixed", enumValue: "Mixed" }, ],
            clubSelected: -1,
            clubArray: [],
            perPageOptions: [10, 25, 50, 100, "All"],
            perPage: 10,
            page: 1,

            isSmallPreview: true,
            smallPreviewColumnsIndex: [4, 0, 8, 9, 6, 12, 2, 1, 15, 16, 17, 18, 19, 5, 3],
            isProcessing: false,
            errorMessage: null,
            loadedResults: [],
            windowWidth: 0,
            columnsIndexes: [],
            columnsHeaders: [
                'Overall Rank',//0
                'Time',//1
                'Points *',//2
                'Gender Rank',//3
                'Gender',//4
                'Age Group Rank',//5
                'Age Group',//6
                'Triathlon Id',//7
                'First Name',//8
                'Last Name',//9
                'Bip Number',//10
                'License Type',//11
                'Club',//12
                'Race Serie',//13
                'Is Relay',//14
                //15         16      17    18     19    20    21    22    23
                'Run/Swim', 'T1', 'Bike', 'T2', 'Run', 'T3', 'S4', 'T4', 'S5',
                'Penalty Appied',//24
                'Penalty Details'//25
            ],
            columnsCurrentHeaders: [],
            smHidden: [3, 4, 5, 6],
            mdHidden: [12, 13],
            lgHidden: [10, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 23, 24, 25],
            smHiddenPreview: [12, 15, 16, 17, 18, 19, 5, 3],
        };
    },
    computed: {
        isFewSeries() {
            return this.seriesLoaded.length > 3;
        },
        perPageValid() {
            return this.perPage == "All" ? this.loadedResultsFiltered.length : this.perPage;
        },
        from() {
            var array = this.loadedResultsVisible;
            var totalVal = this.loadedResultsFiltered.length;

            if (!array || !array.length) return 0;

            var res = (this.page - 1) * this.perPageValid + 1;
            if (res >= totalVal) {
                if (totalVal - this.perPageValid > 0) {
                    res = totalVal - this.perPageValid;
                    if (res === 0) res = 1;
                }
                else {
                    res = 1;
                    this.page = 1;
                }
            }
            return res;
        },
        to() {
            var perPage = this.perPageValid == "All" ? this.loadedResultsFiltered.length : this.perPageValid;
            var array = this.loadedResultsVisible;
            var totalVal = this.loadedResultsFiltered.length;

            if (!array || !array.length) return 0;
            return totalVal > (this.page - 1) * this.perPageValid + this.perPageValid
                ? (this.page - 1) * this.perPageValid + this.perPageValid
                : totalVal;
        },
        total() {
            var array = this.loadedResultsVisible;
            var totalVal = this.loadedResultsFiltered.length;
            return (!array || !array.length)
                ? 0
                : totalVal;
        },
        smallPreviewColumnsHeaders() {
            var self = this;
            var res = [];
            for (var i = 0; i < this.smallPreviewColumnsIndex.length; i++)
                res.push(self.getColumnHeaderByIndex(self.smallPreviewColumnsIndex[i]));

            return res;
        },
        previewColumnStylesHeader() {
            var styleItem = {
                'width': (100 / this.columnsCurrentHeaders.length) + "%",
                'display': 'none',
                'position': 'relative',
                'word-break': 'keep-all',
                'align-items': 'center',
                'background-color': '#0f8f52',
                'border': '1px solid #0f8f52'
            };
            return styleItem;
        },
        previewColumnStyles() {
            var styleItem = {
                'width': (100 / this.columnsCurrentHeaders.length) + "%",
                'display': 'none',
                'position': 'relative',
                'word-break': 'break-word',
                'align-items': 'center',
                'border-bottom': '1px solid dimgray'
            };
            return styleItem;
        },
    },
    methods: {
        previousPage() {
            this.page--;
            this.changePage(this.page)
        },
        nextPage() {
            this.page++;
            this.changePage(this.page)
        },
        changePage(newPage) {
            this.changePageUsers(newPage);
        },
        changePageUsers(newPage) {
            var from = newPage ? (newPage - 1) * this.perPageValid : (this.page - 1) * this.perPageValid;
            if (from >= this.loadedResultsFiltered.length) {
                if (this.loadedResultsFiltered.length - this.perPageValid > 0) {
                    from = this.loadedResultsFiltered.length - this.perPageValid;
                }
                else {
                    from = 0;
                    this.page = 1;
                }
            }

            if (!newPage) {
                this.page = 1;
            }
            this.loadedResultsVisible = [...this.loadedResultsFiltered].splice(from, this.perPageValid);
        },
        searchForUsers(savePage) {
            var self = this;
            if (!savePage) {
                this.page = 1;
            }

            var lowerfilterInput = this.filterInput && this.filterInput.length ? this.filterInput.toLocaleLowerCase() : null;
            this.loadedResultsFiltered = [...this.loadedResults
                .filter(user => {
                    var userName = (user[self.indexFirstName] + " " + user[self.indexLastName]).toLocaleLowerCase();

                    return (!lowerfilterInput || userName.indexOf(lowerfilterInput) > -1 || user[self.indexTiNumber] == lowerfilterInput)
                        && (self.genderSelected == "Mixed" || self.genderSelected == user[self.indexGender])
                        && (!self.ageGroupSelected || self.ageGroupSelected == user[self.indexAgeGroup])
                        && (self.clubSelected === -1 || self.clubSelected == user[self.indexClub] || (!self.clubSelected && (!user[self.indexClub] || user[self.indexClub] == self.emptyCell)))
                        && (!self.isOnlyQualified || user[self.indexPoints] != self.emptyCell)
                        && (self.serieSelected == self.seriesLoaded[0] || (self.serieSelected == self.seriesLoaded[1] && !user[self.indexSerie]) || (user[self.indexSerie] && self.serieSelected == user[self.indexSerie]));
                })];

            this.loadedResultsVisible = [...this.loadedResultsFiltered].splice(0, this.perPageValid);
        },
        exportToExcel() {
            var data = [this.columnsHeaders].concat(this.loadedResultsInput);
            if (this.loadedResults && this.loadedResults.length) {
                data = [this.columnsHeaders].concat(this.loadedResults);
            }

            if (data && data.length > 0) {
                var ws = XLSX.utils.json_to_sheet(data, { skipHeader: true });
                var wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Race Results");
                XLSX.writeFile(wb, "Race Results.xlsx");
            }
            else {
                this.$showError("Records are not loaded");
            }
        },
        getColumnHeaderByIndex(index) {
            return this.columnsHeaders[index];
        },
        getPreviewColumnClass(index, indexRow) {

            let color = indexRow % 2 === 1 ? 'bg-color-brighter' : 'bg-color-darker';
            
            var classObject = {};
            classObject[color] = true;
            if (this.isSmallPreview) {
                if (this.smHiddenPreview.includes(index)) {
                    classObject['d-xl-flex'] = true;
                    classObject['d-md-flex'] = true;
                    classObject['d-lg-flex'] = true;
                }
                else {
                    classObject['d-flex'] = true;
                }
                return classObject;
            }

            if (this.lgHidden.includes(index)) {
                classObject['d-xl-flex'] = true;
            }
            else
                if (this.mdHidden.includes(index)) {
                    classObject['d-xl-flex'] = true;
                    classObject['d-lg-flex'] = true;
                }
                else
                    if (this.smHidden.includes(index)) {
                        classObject['d-xl-flex'] = true;
                        classObject['d-md-flex'] = true;
                        classObject['d-lg-flex'] = true;
                    }
                    else {
                        classObject['d-flex'] = true;
                    }

            return classObject;
        },
        setWindowWidth(event) {
            this.windowWidth = document.body.scrollWidth;

            if (this.isSmallPreview) {
                if (this.windowWidth <= 762) {
                    this.columnsCurrentHeaders = [...this.smallPreviewColumnsHeaders].filter((header, index) => {
                        return !this.smHiddenPreview.includes(this.smallPreviewColumnsIndex[index]);
                    });
                }
                else {
                    this.columnsCurrentHeaders = [...this.smallPreviewColumnsHeaders];
                }
                return;
            }


            if (this.windowWidth) {
                if (this.windowWidth > 1200) {
                    this.columnsCurrentHeaders = this.columnsHeaders;
                }
                else if (this.windowWidth > 992) {
                    this.columnsCurrentHeaders = this.columnsHeaders.filter((header, index) => {
                        return !this.lgHidden.includes(index);
                    });
                }
                else if (this.windowWidth > 720) {
                    this.columnsCurrentHeaders = this.columnsHeaders.filter((header, index) => {
                        return !this.lgHidden.includes(index)
                            && !this.mdHidden.includes(index);
                    });
                }
                else {
                    this.columnsCurrentHeaders = this.columnsHeaders.filter((header, index) => {
                        return !this.lgHidden.includes(index)
                            && !this.mdHidden.includes(index)
                            && !this.smHidden.includes(index)
                    });
                }
            }
        },
        serialize(obj) {
            var str = [];
            for (var p in obj)
                if (obj.hasOwnProperty(p)) {
                    str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                }
            return str.join("&");
        },
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 3000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    var date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        initUsersFilters() {
            var self = this;
            self.ageGroupArray = [];
            self.clubArray = [];
            self.serieSelected = ["All Results", "Without Serie"];
         
            self.loadedResults.forEach(record => {
                if (record[self.indexAgeGroup] && !self.ageGroupArray.filter(group => group.enumValue == record[self.indexAgeGroup]).length) {
                    self.ageGroupArray.push({ label: record[self.indexAgeGroup], enumValue: record[self.indexAgeGroup] });
                    self.ageGroupArray = [...self.ageGroupArray]
                        .sort((a, b) => { return a["enumValue"] > b["enumValue"] ? 1 : -1; });
                }

                if (record[self.indexClub] && record[self.indexClub] != self.emptyCell &&
                    !self.clubArray.filter(club => club.id == record[self.indexClub]).length) {
                    self.clubArray.push({ label: record[self.indexClub], id: record[self.indexClub] })
                }

                if (record[self.indexSerie] && !self.isFewSeries) {
                    if (!self.seriesLoaded.includes(record[self.indexSerie])) {
                        self.seriesLoaded.push(record[self.indexSerie]);
                    }
                }
            });

            self.ageGroupArray.unshift({ label: "All", enumValue: null });
            self.serieSelected = "All Results"
            self.clubArray = [...self.clubArray]
                .sort((a, b) => { return a["label"] > b["label"] ? 1 : -1; });
            self.clubArray.unshift({ label: "All", id: -1 }, { label: "WithoutClub", id: null });
        },
        init() {
            this.columnsIndexes = [];
            for (var index = 0; index < this.columnsHeaders.length; index++)
                this.columnsIndexes.push(index);

            if (this.raceId && this.raceId > 0) {
                this.loadRaceResult();
            }
            else if (this.loadedResultsInput && this.loadedResultsInput.length) {
                this.scrollToTopPage();
                this.loadedResults = this.loadedResultsInput;
                this.initUsersFilters();
                this.searchForUsers();
            }
            else {
                this.isProcessing = true;
                //this.errorMessage = "Race idetifier or loaded results are not provided for race previwer.";
            }
        },
        loadRaceResult(raceIdDownload) {
            self = this;
            var isDownload = raceIdDownload > 0;
            var raceIdCurrent = isDownload ? raceIdDownload : self.raceId;

            if (raceIdCurrent) {
                if (!isDownload) {
                    self.scrollToTopPage();
                }
                self.isProcessing = true;

                var query = self.serialize({ raceId: raceIdCurrent });
                svc.rankingGetRaceResult(query)
                    .then(response => {
                        if (response && response.body.outputData && response.body.isSuccess) {
                            self.loadedResults = response.body.outputData ? response.body.outputData : null;
                            if (isDownload) {
                                self.exportToExcel();
                            }
                            else {
                                self.scrollToTopPage();
                            }
                        }
                        else {
                            self.errorMessage = response && response.body && response.body.errorMesssage
                                ? response.body.errorMesssage
                                : "Error while retrieving data.";
                        }
                        self.initUsersFilters();
                        self.searchForUsers();
                        self.isProcessing = false;
                    }, () => {
                        self.errorMessage = "Error while retrieving data."
                        self.isProcessing = false;
                    });
            }
            else {
                self.isProcessing = true;
            }
        },
        scrollToTopPage() {
            setTimeout(() => {
                window.scrollTo({ top: 150, behavior: 'smooth' });
            }, 0);
        }
    },
    mounted() {
        var self = this;
        self.init()

        EventBus.$off('race-result-download');
        EventBus.$on('race-result-download', (raceId) => {
            if (raceId) {
                self.loadRaceResult(raceId);
            }
            else {
                self.exportToExcel();
            }
        });

        EventBus.$off('race-result-reload');
        EventBus.$on('race-result-reload', () => setTimeout(()=> { self.loadRaceResult(); }, 0));

        self.$nextTick(() => {
            window.addEventListener('resize', self.setWindowWidth);
            self.setWindowWidth();
        });
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setWindowWidth);
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/race-result/race-result.js